import { Component, OnInit } from '@angular/core';
import { ApiservicesService } from '../../../apiservices.service';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';
import { UrlService } from '../../../services/url.service';

@Component({
  selector: 'app-mitrs2',
  templateUrl: './mitrs2.component.html',
  styleUrls: ['./mitrs2.component.css']
})
export class Mitrs2Component implements OnInit {
  //Open Window
  openedWindowStatus: any = null;

  //UI Status Variables
  LoaderStatus: boolean = false;
  SearchStatus: boolean = false;
  SectionListStatus: boolean = false;
  YearAssessmentListStatus: boolean = false;
  S80S82DescriptionStatus: boolean = false;
  S22EBS22DescriptionStatus: boolean = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Input Variables
  SearchTypeInput: any = "";
  TINInput: any = "";
  AgentInput: any = "";
  FormTypeInput: any = "";
  YearAssessmentInput: any = "";
  AcknowledgementYearAssessmentInput: any = "";
  SectionInput: any = "";

  //UI View Variables
  TINView: any = "";
  ItGrpCdView: any = "";
  TaxpNameView: any = "";
  BranchNameView: any = "";
  SectionView: any = "";

  //UI List Variables
  FormTypeList: any[] = [];
  SectionList: any[] = [];
  YearAssessmentList: any[] = [];

  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionStaffIDNo: any = "";
  SessionRoles: any = [];

  //Array Variables
  AgentList: any = new Array;

  //Datatable
  displayedColumns = ['jenisseksyen', 'jenisborang', 'tahun', 'action'];
  constructor(private apiServices: ApiservicesService, private url: UrlService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionStaffIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    this.SessionRoles = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffRoles') || '');
    this.top.updateTotal();
  }

  onChangeIDType() {
    this.ResetValue();
  }
  ResetValue() {
    this.SearchStatus = false;
    this.SectionListStatus = false;
    this.YearAssessmentListStatus = false;

    this.AgentInput = "";
    this.FormTypeInput = "";
    this.SectionInput = "";

    this.TINView = "";
    this.ItGrpCdView = "";
    this.TaxpNameView = "";
    this.SectionView = "";

    this.FormTypeList = [];
    this.YearAssessmentList = [];
    this.SectionList = [];
  }
  Semula() {
    this.LoaderStatus = false;
    this.SearchStatus = false;
    this.AlertStatus = false;
    this.SectionListStatus = false;
    this.YearAssessmentListStatus = false;

    this.AgentInput = "";
    this.SearchTypeInput = "";
    this.TINInput = "";
    this.FormTypeInput = "";
    this.SectionInput = "";

    this.TINView = "";
    this.ItGrpCdView = "";
    this.TaxpNameView = "";
    this.SectionView = "";

    this.FormTypeList = [];
    this.YearAssessmentList = [];
    this.SectionList = [];
  }
  async Submit(SearchType: any, TIN: any) {
    this.ResetValue();
    this.LoaderStatus = true;
    if (TIN === "" || SearchType === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.SearchStatus = false;
    } else {
      let Params = {};
      if (SearchType === "6") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "itRefNo": Number(TIN)
        };
      } else if (SearchType === "7") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "newEmplRefNo": Number(TIN)
        };
      }
      const result = await this.apiServices.MitrsFormDetail(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        this.GetAgent(this.SessionFirmID);
        this.TINView = result.taxPayer.iT_Ref_No;
        this.ItGrpCdView = result.taxPayer.jenisFail;
        this.TaxpNameView = result.taxPayer.nama;
        this.BranchNameView = result.taxPayer.namaCaw;
        if (this.ItGrpCdView === "LE") {
          this.S22EBS22DescriptionStatus = true;
          this.S80S82DescriptionStatus = false;
        } else {
          this.S22EBS22DescriptionStatus = false;
          this.S80S82DescriptionStatus = true;
        }
        result.eBorang.forEach((currentValue: any, index: any) => {
          this.FormTypeList.push(result.eBorang[index]);
        });
        this.SearchStatus = true;
        this.LoaderStatus = false;
      }
    }
  }
  async Login(FormType: any, TIN: any, AgentID: any, YearAssessment: any, Section: any) {
    if (AgentID === "" || FormType === "" || Section === "" || YearAssessment === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila pilih masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let URL = "", EncUserName = "", EncClientID = "", EncTAIDNo = "", EncFirmID = "", EncPassword = "";
      let Params = {
        "firmID": Number(this.SessionFirmID),
        "itRefNo": Number(TIN),
        "staffID": Number(this.SessionStaffID),
        "taxAgentID": Number(AgentID),
        "formType": FormType,
        "formYear": YearAssessment,
        "formSection": Section
      }
      //let Params = {};
      //switch (FormType) {
      //  case "C":
      //  case "PT":
      //  case "B":
      //    Params = {
      //      "firmID": Number(this.SessionFirmID),
      //      "itRefNo": Number(TIN),
      //      "staffID": Number(this.SessionStaffID),
      //      "taxAgentID": Number(AgentID),
      //      "formType": FormType,
      //      "formYear": YearAssessment
      //    }
      //    break;
      //}
      const result = await this.apiServices.MitrsFormlogin(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        //this.SearchStatus = false;
      } else {
        EncUserName = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
        EncClientID = await this.EncryptDecryptText('201', TIN);
        EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentIDNo);
        EncFirmID = await this.EncryptDecryptText('201', this.SessionFirmID);
        EncPassword = await this.EncryptDecryptText('201', result.password);

        switch (FormType) {
          case "C":
          case "PT":
          case "BE":
          case "B":
          case "BT":
          case "M":
          case "MT":
          case "C1":
          case "TA":
          case "TC":
          case "TR":
          case "TP":
          case "TF":
          case "P":
          case "LE1":
            URL = result.url + "?UserName=" + EncUserName + "&NoRujukan=" + EncClientID + "&TAIDNo=" + EncTAIDNo + "&FirmID=" + EncFirmID + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + FormType + "&JenisSeksyen=" + Section + "&TahunTaksiran=" + YearAssessment + "&language=en-US";
            break;
        }
        this.openWindow(URL);
      }
    }
  }
  async GetAgent(FirmID: any) {
    let Params = {
      "FirmID": FirmID,
      "Role": "0204",
      "NonExpiredTaxAgent": false
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }
  async GetAcknowledment(SectionType:any, FormType: any, YearAssessment: any, TaxRefNum: any) {
    this.LoaderStatus = true;
    let Params;

    if (SectionType === "" || FormType === "" || YearAssessment === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
    else
    {
      Params = {
        "firmID": this.SessionFirmID,
        "itRefNo": TaxRefNum,
        "formType": FormType,
        "formYear": YearAssessment,
        "sectionType": SectionType
      }
      const result = await this.apiServices.MitrsFormAcknowledgment(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.LoaderStatus = false;
        this.GoAcknowledgment(result.url, result.paramBody);
      }
    }
  }
  GoAcknowledgment(ParamUrl: any, ParamBody: any) {

    var form = document.createElement("form");
    form.target = "Map";
    form.method = "POST";
    form.action = ParamUrl;
    for (var x = 0; x < ParamBody.length; x++) {
      var elementArr = document.createElement("input");
      elementArr.name = ParamBody[x].paramName;
      elementArr.value = ParamBody[x].paramValue;
      elementArr.type = "hidden";
      form.appendChild(elementArr);
    }
    document.body.appendChild(form);



    var map = window.open("", "Map", "");

    if (map) {
      this.LoaderStatus = false;
      form.submit();
    } else {
      alert('You must allow popups for this map to work.');
    }
  }
  async EncryptDecryptText(Type: any, Text: any) {
    let EncryptedText;
    const result = await this.apiServices.GetEncryptDecrypt(Type, Text);
    EncryptedText = JSON.parse(JSON.stringify(result));
    return EncryptedText;
  }
  ChangeFormTypeRegister(FormType: any) {
    this.SectionInput = "";
    this.SectionList = [];
    this.FormTypeList.forEach(currentValue => {
      if (FormType === currentValue.formName) {
        currentValue.sectionList.forEach((currentValueInner: any) => {
          this.SectionList.push(currentValueInner);
        });
      }
    });

    this.SectionList.forEach(item => {
      if (item.section === "S82") {
        item.sectionDesc = "Seksyen 82B";
      } else if (item.section === "S80") {
        item.sectionDesc = "Seksyen 80/81";
      } else if (item.section === "S22E") {
        item.sectionDesc = "Seksyen 22EB";
      } else if (item.section === "S22") {
        item.sectionDesc = "Seksyen 22";
      }

    });

    this.SectionList.sort((a, b) => b.section.localeCompare(a.section));

    this.SectionListStatus = true;
  }
  ChangeSectionRegister(Section: any) {
    this.YearAssessmentInput = "";
    this.YearAssessmentList = [];
    this.SectionList.forEach(currentValue => {
      if (Section === currentValue.section) {
        currentValue.formYear.forEach((currentValueInner: any) => {
          this.YearAssessmentList.push(currentValueInner);
        });
      }
    });
    this.YearAssessmentList.sort(function (a, b) {
      return b - a; // sort in descending order
    });
    this.YearAssessmentListStatus = true;
  }
  openWindow(URL: any) {
    if (this.openedWindowStatus === null || this.openedWindowStatus.closed)
      this.openedWindowStatus = window.open(URL, "_blank");
    else
      this.openedWindowStatus.focus();
  }
}
